import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'src/app/services/global.service';
import { NewCustomerService } from 'src/app/services/new-customer.service';
import { Profile } from 'selenium-webdriver/firefox';

@Component({
  selector: 'app-new-customer',
  templateUrl: './new-customer.component.html',
  styleUrls: ['./new-customer.component.css']
})
export class NewCustomerComponent implements OnInit {
  token: string;
  selectedNewCustomer: any = {};

  constructor(
    private modalService: NgbModal,
    private newCustomerService: NewCustomerService,
    private globals: GlobalService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    if(!this.token){
      this.token = this.globals.getToken();
    }
    
  }

  addNewUser(selectedNewCustomer, cPassowrd){
    if(selectedNewCustomer.password == cPassowrd)
    {
      delete this.selectedNewCustomer.description;
      let obj: object = {
        user: this.selectedNewCustomer,
        profile: 1
      }
      this.newCustomerService.newUser(this.token, obj).subscribe(
        res =>{
          this.activeModal.close();
        },
        err =>{
          console.error("Errore in addNewUser: ", err);
          
        }
      )
    }
  }

  canceling() {
    this.activeModal.close('cancel');
  }

}
